<template>
  <a-drawer
    :maskClosable="false"
    width="70%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
      <span v-if="isAllocateMode && targetFolder" class="target-folder-info">
        目标文件夹: {{ targetFolder.name }}
      </span>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <vrWork :vrWorkId="vrWorkId" ref="vrWork"></vrWork>

    <!-- 分配模式下的操作按钮 -->
    <div v-if="isAllocateMode" class="form-actions">
      <div class="action-buttons">
        <a-button @click="onClose" style="margin-right: 8px">取消</a-button>
        <a-button type="primary" :loading="submitLoading" @click="submitForm" :disabled="!hasSelectedWorks">
          确认分配
        </a-button>
      </div>
    </div>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'
import { editSys, addObj } from '@/api/VR/vrWork'
import { folderPage } from '@/api/VR/folder'
import vrWork from '../../vrWork/index.vue'
export default {
  name: 'CreateForm',
  components: { vrWork },
  data() {
    return {
      submitLoading: false,
      vrWorkId: 2,
      showLoading: false,
      // 表单参数
      form: {
        scenesEditParams: [],
      },
      open: false,
      formTitle: '',
      isAllocateMode: false, // 是否为分配模式
      targetFolder: null, // 目标文件夹
      selectedWorksCount: 0, // 已选择的工件数量
      checkSelectionTimer: null, // 检查选择的定时器
    }
  },
  filters: {},
  created() {
    // console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  beforeDestroy() {
    this.stopSelectionCheck()
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
    hasSelectedWorks() {
      return this.selectedWorksCount > 0
    },
  },
  watch: {
    // 监听抽屉打开状态
    open(newVal) {
      if (newVal && this.isAllocateMode) {
        this.selectedWorksCount = 0
        // 分配模式下，启动定时器检查选择状态
        this.startSelectionCheck()
      } else {
        // 关闭时停止定时器
        this.stopSelectionCheck()
      }
    },
  },
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
          that.isAllocateMode = false
          that.targetFolder = null
          that.stopSelectionCheck()
        },
        onCancel() { },
      })
    },

    /** 启动选择状态检查 */
    startSelectionCheck() {
      this.stopSelectionCheck() // 先停止之前的定时器
      this.checkSelectionTimer = setInterval(() => {
        this.checkSelectedWorks()
      }, 500) // 每500ms检查一次
    },

    /** 停止选择状态检查 */
    stopSelectionCheck() {
      if (this.checkSelectionTimer) {
        clearInterval(this.checkSelectionTimer)
        this.checkSelectionTimer = null
      }
    },

    /** 检查已选择的工件 */
    checkSelectedWorks() {
      if (this.$refs.vrWork && this.$refs.vrWork.selectedRowKeys) {
        this.selectedWorksCount = this.$refs.vrWork.selectedRowKeys.length
      } else {
        this.selectedWorksCount = 0
      }
    },

    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        scenesEditParams: [{ originalImageUrl: '', extendS1: '', sceneName: '' }],
      }
    },
    /** 修改按钮操作 */
    handleUpdate(row, targetFolder, isAllocate = false) {
      if (isAllocate) {
        this.isAllocateMode = true
        this.targetFolder = targetFolder || row // 如果传入了 targetFolder，使用它，否则使用 row
        this.formTitle = '选择要分配的作品'
      } else {
        this.isAllocateMode = false
        this.targetFolder = null
        this.formTitle = '选择作品'
      }
      this.reset()
      this.dataForm = row
      this.open = true
    },
    /** 提交按钮 */
    submitForm: function () {
      // 分配模式：调用分配接口
      if (this.isAllocateMode) {
        return this.handleAllocate()
      }

      console.log(this.form, '对对对对对对')
      let obj = false
      if (this.form.scenesEditParams.length) {
        this.form.scenesEditParams.forEach((v) => {
          if (!v.sceneName || !v.originalImageUrl) {
            obj = true
          }
        })
        if (obj) return this.$message.error('请先把数据填写完整在进行添加')
      }
      console.log(this.showIdIndex, 'showIdIndexshowIdIndex')
      if (this.showIdIndex === 1) {
        if (this.showId === 1) {
          const arr = [...this.dataForm.scenesInfos, ...this.form.scenesEditParams]
          const array = this.uniqueSceneNames(arr)
          console.log(array, 'arrayarray')
          this.dataForm.scenesEditParams = array
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
        } else {
          const objo = this.form.scenesEditParams[0]
          this.dataForm.scenesInfos.forEach((v) => {
            if (v.sceneId === objo.sceneId) {
              v.sceneName = objo.sceneName
            }
          })
          this.dataForm.scenesEditParams = this.dataForm.scenesInfos
        }
        editSys(this.dataForm)
          .then((res) => {
            if (this.showId === 1) {
              this.$message.success('新增成功', 3)
            } else {
              this.$message.success('修改成功', 3)
            }
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
            this.showLoading = false
          })
      } else {
        if (!this.form.workName) return this.$message.error('请输入作品名称')
        // this.
        this.form.scenesAddParam = this.form.scenesEditParams
        this.form.orderId = ''
        this.form.tenantFirmId = this.$tenantFirmId
        addObj(this.form)
          .then((res) => {
            this.$message.success('新增成功', 3)
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
            this.showLoading = false
          })
        console.log(this.form, '顶顶顶顶吗')
      }
    },

    /** 处理分配逻辑 */
    handleAllocate() {
      // 获取选中的作品ID数组 (workId)
      const selectedWorkIds = this.$refs.vrWork ? this.$refs.vrWork.selectedRowKeys : []

      if (!selectedWorkIds || selectedWorkIds.length === 0) {
        this.$message.error('请选择要分配的作品')
        return
      }

      if (!this.targetFolder || !this.targetFolder.id) {
        this.$message.error('目标文件夹信息不完整')
        return
      }

      // 显示分配确认对话框
      const that = this
      this.$confirm({
        title: '确认分配',
        content: `确定要将 ${selectedWorkIds.length} 个作品分配到文件夹 "${this.targetFolder.name}" 中吗？`,
        onOk() {
          return new Promise((resolve, reject) => {
            const allocateData = {
              objIds: selectedWorkIds,
              parentId: that.targetFolder.id,
              sort: 0,
              type: 1,
            }

            that.submitLoading = true
            folderPage(allocateData)
              .then((res) => {
                if (res.success || res.code === 200) {
                  that.$message.success(`成功分配 ${selectedWorkIds.length} 个作品到文件夹 "${that.targetFolder.name}"`, 3)
                  that.open = false
                  that.isAllocateMode = false
                  that.targetFolder = null
                  that.stopSelectionCheck()
                  that.$emit('ok')
                  resolve()
                } else {
                  that.$message.error(res.message || '分配失败')
                  reject(new Error(res.message || '分配失败'))
                }
              })
              .catch((err) => {
                console.error('分配失败:', err)
                that.$message.error('分配失败，请重试')
                reject(err)
              })
              .finally(() => {
                that.submitLoading = false
              })
          })
        },
        onCancel() {
          // 用户取消分配
        },
      })
    },
  },
}
</script>
<style lang="less" scoped>
.form_sub {
  display: flex;
  justify-content: flex-end;
}

.form_con {
  position: relative;

  .form_sub {
    position: absolute;
    right: 0;
    top: 120px;
  }
}

.target-folder-info {
  margin-left: 16px;
  color: #1890ff;
  font-weight: normal;
  font-size: 14px;
}

.form-actions {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.action-buttons {
  text-align: right;
}
</style>
